import { render, staticRenderFns } from "./CarImageName.vue?vue&type=template&id=c0d46480&scoped=true"
import script from "./CarImageName.vue?vue&type=script&lang=js"
export * from "./CarImageName.vue?vue&type=script&lang=js"
import style0 from "./CarImageName.vue?vue&type=style&index=0&id=c0d46480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d46480",
  null
  
)

export default component.exports